/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { SharkDooDoo, SharkDooDooInterface } from "../SharkDooDoo";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "stageId",
            type: "uint8",
          },
          {
            internalType: "uint16",
            name: "maxSupply",
            type: "uint16",
          },
          {
            internalType: "uint32",
            name: "startTime",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "endTime",
            type: "uint32",
          },
          {
            internalType: "uint160",
            name: "mintPrice",
            type: "uint160",
          },
        ],
        internalType: "struct SharkDooDoo.StageInfo",
        name: "_initStageInfo",
        type: "tuple",
      },
      {
        internalType: "string",
        name: "_initBaseURI",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextOwnerToExplicitlySet",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "stageId",
            type: "uint8",
          },
          {
            internalType: "uint16",
            name: "maxSupply",
            type: "uint16",
          },
          {
            internalType: "uint32",
            name: "startTime",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "endTime",
            type: "uint32",
          },
          {
            internalType: "uint160",
            name: "mintPrice",
            type: "uint160",
          },
        ],
        internalType: "struct SharkDooDoo.StageInfo",
        name: "_stageInfo",
        type: "tuple",
      },
    ],
    name: "nextStage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "amount",
        type: "uint8",
      },
    ],
    name: "publicMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "reserve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stageInfo",
    outputs: [
      {
        internalType: "uint8",
        name: "stageId",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "maxSupply",
        type: "uint16",
      },
      {
        internalType: "uint32",
        name: "startTime",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "endTime",
        type: "uint32",
      },
      {
        internalType: "uint160",
        name: "mintPrice",
        type: "uint160",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "redeemer",
            type: "address",
          },
          {
            internalType: "uint8",
            name: "stageId",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "amount",
            type: "uint8",
          },
        ],
        internalType: "struct SharkDooDoo.NFTVoucher",
        name: "voucher",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "uint8",
        name: "amount",
        type: "uint8",
      },
    ],
    name: "whitelistMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x6101606040526000805560006007553480156200001b57600080fd5b5060405162003446380380620034468339810160408190526200003e91620003e9565b604080518082018252600b8082526a536861726b446f6f446f6f60a81b60208084018290528451808601865260018152603160f81b8183015285518087018752938452838201929092528451808601909552600485526314d2111160e21b908501529192600a8251620000b990600190602086019062000280565b508151620000cf90600290602085019062000280565b5060805250620000e19050336200022e565b81516020928301208151918301919091206101008290526101208190524660c0818152604080517f8b73c3c69bb8fe3d512ecc4cf759cc79239f7b179b0ffacaa9a75d522b39400f8188018190528183019690965260608181019590955260808101939093523060a0808501829052825180860382018152949093019091528251928601929092209052901b60e0526101405281516200018891600a919084019062000280565b505080516009805460208401516040850151606086015160809096015160ff90951662ffffff199093169290921761010061ffff90921691909102176301000000600160581b031916630100000063ffffffff9283160263ffffffff60381b191617670100000000000000919094160292909217600160581b600160f81b0319166b0100000000000000000000006001600160a01b039092169190910217905562000561565b600880546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b8280546200028e906200050e565b90600052602060002090601f016020900481019282620002b25760008555620002fd565b82601f10620002cd57805160ff1916838001178555620002fd565b82800160010185558215620002fd579182015b82811115620002fd578251825591602001919060010190620002e0565b506200030b9291506200030f565b5090565b5b808211156200030b576000815560010162000310565b600082601f83011262000337578081fd5b81516001600160401b038111156200035357620003536200054b565b602062000369601f8301601f19168201620004db565b82815285828487010111156200037d578384fd5b835b838110156200039c5785810183015182820184015282016200037f565b83811115620003ad57848385840101525b5095945050505050565b80516001600160a01b0381168114620003cf57600080fd5b919050565b805163ffffffff81168114620003cf57600080fd5b60008082840360c0811215620003fd578283fd5b60a08112156200040b578283fd5b5062000416620004b0565b835160ff8116811462000427578384fd5b8152602084015161ffff811681146200043e578384fd5b60208201526200045160408501620003d4565b60408201526200046460608501620003d4565b60608201526200047760808501620003b7565b608082015260a08401519092506001600160401b0381111562000498578182fd5b620004a68582860162000326565b9150509250929050565b60405160a081016001600160401b0381118282101715620004d557620004d56200054b565b60405290565b604051601f8201601f191681016001600160401b03811182821017156200050657620005066200054b565b604052919050565b600181811c908216806200052357607f821691505b602082108114156200054557634e487b7160e01b600052602260045260246000fd5b50919050565b634e487b7160e01b600052604160045260246000fd5b60805160a05160c05160e05160601c610100516101205161014051612e79620005cd60003960006121db0152600061222a015260006122050152600061215e01526000612188015260006121b2015260008181611a5601528181611a800152611f340152612e796000f3fe60806040526004361061014c5760003560e01c80636352211e116100bc5780636352211e1461037b57806370a082311461039b578063715018a6146103bb578063858e83b5146103d05780638da5cb5b146103e357806395d89b41146103f8578063a22cb4651461040d578063ad1191fa1461042d578063b88d4fde1461044d578063c87b56dd1461046d578063cc47a40b1461048d578063d7224ba0146104ad578063e985e9c5146104c3578063f2fde38b1461050c57600080fd5b806301ffc9a71461015157806306fdde0314610186578063081812fc146101a8578063095ea7b3146101e057806318160ddd1461020257806323b872dd146102215780632bf87116146102415780632f745c59146102d35780633425e8ba146102f35780633ccfd60b1461030657806342842e0e1461031b5780634f6ccce71461033b57806355f804b31461035b575b600080fd5b34801561015d57600080fd5b5061017161016c366004612891565b61052c565b60405190151581526020015b60405180910390f35b34801561019257600080fd5b5061019b610599565b60405161017d9190612b03565b3480156101b457600080fd5b506101c86101c3366004612a39565b61062b565b6040516001600160a01b03909116815260200161017d565b3480156101ec57600080fd5b506102006101fb366004612866565b6106bb565b005b34801561020e57600080fd5b506000545b60405190815260200161017d565b34801561022d57600080fd5b5061020061023c366004612779565b6107cf565b34801561024d57600080fd5b506009546102929060ff81169061ffff6101008204169063ffffffff63010000008204811691600160381b8104909116906001600160a01b03600160581b9091041685565b6040805160ff909616865261ffff909416602086015263ffffffff928316938501939093521660608301526001600160a01b0316608082015260a00161017d565b3480156102df57600080fd5b506102136102ee366004612866565b6107da565b61020061030136600461290e565b610947565b34801561031257600080fd5b50610200610bb9565b34801561032757600080fd5b50610200610336366004612779565b610bfb565b34801561034757600080fd5b50610213610356366004612a39565b610c16565b34801561036757600080fd5b506102006103763660046128c9565b610c78565b34801561038757600080fd5b506101c8610396366004612a39565b610cbe565b3480156103a757600080fd5b506102136103b6366004612725565b610cd0565b3480156103c757600080fd5b50610200610d61565b6102006103de366004612a51565b610d9a565b3480156103ef57600080fd5b506101c8610ed8565b34801561040457600080fd5b5061019b610ee7565b34801561041957600080fd5b50610200610428366004612835565b610ef6565b34801561043957600080fd5b506102006104483660046129a3565b610fb8565b34801561045957600080fd5b506102006104683660046127b9565b61117b565b34801561047957600080fd5b5061019b610488366004612a39565b6111b4565b34801561049957600080fd5b506102006104a8366004612866565b611281565b3480156104b957600080fd5b5061021360075481565b3480156104cf57600080fd5b506101716104de366004612741565b6001600160a01b03918216600090815260066020908152604080832093909416825291909152205460ff1690565b34801561051857600080fd5b50610200610527366004612725565b6112ef565b60006001600160e01b031982166380ac58cd60e01b148061055d57506001600160e01b03198216635b5e139f60e01b145b8061057857506001600160e01b0319821663780e9d6360e01b145b8061059357506301ffc9a760e01b6001600160e01b03198316145b92915050565b6060600180546105a890612d6c565b80601f01602080910402602001604051908101604052809291908181526020018280546105d490612d6c565b80156106215780601f106105f657610100808354040283529160200191610621565b820191906000526020600020905b81548152906001019060200180831161060457829003601f168201915b5050505050905090565b6000610638826000541190565b61069f5760405162461bcd60e51b815260206004820152602d60248201527f455243373231413a20617070726f76656420717565727920666f72206e6f6e6560448201526c3c34b9ba32b73a103a37b5b2b760991b60648201526084015b60405180910390fd5b506000908152600560205260409020546001600160a01b031690565b60006106c682610cbe565b9050806001600160a01b0316836001600160a01b031614156107355760405162461bcd60e51b815260206004820152602260248201527f455243373231413a20617070726f76616c20746f2063757272656e74206f776e60448201526132b960f11b6064820152608401610696565b336001600160a01b0382161480610751575061075181336104de565b6107bf5760405162461bcd60e51b815260206004820152603960248201527f455243373231413a20617070726f76652063616c6c6572206973206e6f74206f6044820152781ddb995c881b9bdc88185c1c1c9bdd995908199bdc88185b1b603a1b6064820152608401610696565b6107ca83838361138c565b505050565b6107ca8383836113e8565b60006107e583610cd0565b821061083e5760405162461bcd60e51b815260206004820152602260248201527f455243373231413a206f776e657220696e646578206f7574206f6620626f756e604482015261647360f01b6064820152608401610696565b600080549080805b838110156108e7576000818152600360209081526040918290208251808401909352546001600160a01b038116808452600160a01b9091046001600160401b0316918301919091521561089857805192505b876001600160a01b0316836001600160a01b031614156108d457868414156108c65750935061059392505050565b836108d081612da7565b9450505b50806108df81612da7565b915050610846565b5060405162461bcd60e51b815260206004820152602e60248201527f455243373231413a20756e61626c6520746f2067657420746f6b656e206f662060448201526d0deeedccae440c4f240d2dcc8caf60931b6064820152608401610696565b336000908152600b60205260409020600954815460ff91821691161015610a0d5761097385858561176e565b60095460ff166109896040870160208801612a51565b60ff16146109c75760405162461bcd60e51b815260206004820152600b60248201526a57726f6e6720737461676560a81b6044820152606401610696565b6109d76040860160208701612a51565b815460ff191660ff919091161781556109f66060860160408701612a51565b815460ff919091166101000261ff00199091161781555b6009546301000000900463ffffffff16421015610a3c5760405162461bcd60e51b815260040161069690612b6b565b600954600160381b900463ffffffff16421115610a6b5760405162461bcd60e51b815260040161069690612b3f565b805460ff61010090910481169083161115610abc5760405162461bcd60e51b81526020600482015260116024820152702737ba1032b737bab3b4103932b6b0b4b760791b6044820152606401610696565b60095461ffff6101009091041660ff8316610ad660005490565b610ae09190612c6c565b1115610b285760405162461bcd60e51b8152602060048201526017602482015276457863656564207374616765206d617820737570706c7960481b6044820152606401610696565b600954610b499060ff841690600160581b90046001600160a01b0316612c98565b6001600160a01b0316341015610b715760405162461bcd60e51b815260040161069690612b16565b610b7e338360ff166118a4565b805482908290600190610b9a908490610100900460ff16612d06565b92506101000a81548160ff021916908360ff1602179055505050505050565b33610bc2610ed8565b6001600160a01b031614610be85760405162461bcd60e51b815260040161069690612b95565b610bf9610bf3610ed8565b476118be565b565b6107ca8383836040518060200160405280600081525061117b565b600080548210610c745760405162461bcd60e51b815260206004820152602360248201527f455243373231413a20676c6f62616c20696e646578206f7574206f6620626f756044820152626e647360e81b6064820152608401610696565b5090565b33610c81610ed8565b6001600160a01b031614610ca75760405162461bcd60e51b815260040161069690612b95565b8051610cba90600a9060208401906125f6565b5050565b6000610cc9826119d4565b5192915050565b60006001600160a01b038216610d3c5760405162461bcd60e51b815260206004820152602b60248201527f455243373231413a2062616c616e636520717565727920666f7220746865207a60448201526a65726f206164647265737360a81b6064820152608401610696565b506001600160a01b03166000908152600460205260409020546001600160801b031690565b33610d6a610ed8565b6001600160a01b031614610d905760405162461bcd60e51b815260040161069690612b95565b610bf96000611b7d565b60095460ff16600214610de95760405162461bcd60e51b8152602060048201526017602482015276141d589b1a58c81b5a5b9d081b9bdd081cdd185c9d1959604a1b6044820152606401610696565b6009546301000000900463ffffffff16421015610e185760405162461bcd60e51b815260040161069690612b6b565b600954600160381b900463ffffffff16421115610e475760405162461bcd60e51b815260040161069690612b3f565b611b5760ff8216610e5760005490565b610e619190612c6c565b1115610e7f5760405162461bcd60e51b815260040161069690612bca565b600954610ea09060ff831690600160581b90046001600160a01b0316612c98565b6001600160a01b0316341015610ec85760405162461bcd60e51b815260040161069690612b16565b610ed5338260ff166118a4565b50565b6008546001600160a01b031690565b6060600280546105a890612d6c565b6001600160a01b038216331415610f4c5760405162461bcd60e51b815260206004820152601a60248201527922a9219b9918a09d1030b8383937bb32903a379031b0b63632b960311b6044820152606401610696565b3360008181526006602090815260408083206001600160a01b03871680855290835292819020805460ff191686151590811790915590519081529192917f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31910160405180910390a35050565b33610fc1610ed8565b6001600160a01b031614610fe75760405162461bcd60e51b815260040161069690612b95565b600954815160ff918216911610156110415760405162461bcd60e51b815260206004820152601c60248201527f43616e6e6f742073657420746f2070726576696f7573207374616765000000006044820152606401610696565b611b5761ffff16816020015161ffff1611156110975760405162461bcd60e51b815260206004820152601560248201527453657420657863656564206d617820737570706c7960581b6044820152606401610696565b8051600260ff90911611156110e65760405162461bcd60e51b81526020600482015260156024820152745075626c69632069732066696e616c20737461676560581b6044820152606401610696565b80516009805460208401516040850151606086015160809096015160ff90951662ffffff199093169290921761010061ffff90921691909102176affffffffffffffff0000001916630100000063ffffffff9283160263ffffffff60381b191617600160381b919094160292909217600160581b600160f81b031916600160581b6001600160a01b0390921691909102179055565b6111868484846113e8565b61119284848484611bcf565b6111ae5760405162461bcd60e51b815260040161069690612bf7565b50505050565b60606111c1826000541190565b6112255760405162461bcd60e51b815260206004820152602f60248201527f4552433732314d657461646174613a2055524920717565727920666f72206e6f60448201526e3732bc34b9ba32b73a103a37b5b2b760891b6064820152608401610696565b600061122f611cdd565b9050600081511161124f576040518060200160405280600081525061127a565b8061125984611cec565b60405160200161126a929190612a97565b6040516020818303038152906040525b9392505050565b3361128a610ed8565b6001600160a01b0316146112b05760405162461bcd60e51b815260040161069690612b95565b611b57816112bd60005490565b6112c79190612c6c565b11156112e55760405162461bcd60e51b815260040161069690612bca565b610cba82826118a4565b336112f8610ed8565b6001600160a01b03161461131e5760405162461bcd60e51b815260040161069690612b95565b6001600160a01b0381166113835760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b6064820152608401610696565b610ed581611b7d565b60008281526005602052604080822080546001600160a01b0319166001600160a01b0387811691821790925591518593918516917f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92591a4505050565b60006113f3826119d4565b80519091506000906001600160a01b0316336001600160a01b0316148061142a57503361141f8461062b565b6001600160a01b0316145b8061143c5750815161143c90336104de565b9050806114a65760405162461bcd60e51b815260206004820152603260248201527f455243373231413a207472616e736665722063616c6c6572206973206e6f74206044820152711bdddb995c881b9bdc88185c1c1c9bdd995960721b6064820152608401610696565b846001600160a01b031682600001516001600160a01b03161461151a5760405162461bcd60e51b815260206004820152602660248201527f455243373231413a207472616e736665722066726f6d20696e636f72726563746044820152651037bbb732b960d11b6064820152608401610696565b6001600160a01b03841661157e5760405162461bcd60e51b815260206004820152602560248201527f455243373231413a207472616e7366657220746f20746865207a65726f206164604482015264647265737360d81b6064820152608401610696565b61158e600084846000015161138c565b6001600160a01b03851660009081526004602052604081208054600192906115c09084906001600160801b0316612cc7565b82546101009290920a6001600160801b038181021990931691831602179091556001600160a01b0386166000908152600460205260408120805460019450909261160c91859116612c4a565b82546001600160801b039182166101009390930a9283029190920219909116179055506040805180820182526001600160a01b0380871682526001600160401b03428116602080850191825260008981526003909152948520935184549151909216600160a01b026001600160e01b03199091169190921617179055611693846001612c6c565b6000818152600360205260409020549091506001600160a01b0316611724576116bd816000541190565b156117245760408051808201825284516001600160a01b0390811682526020808701516001600160401b039081168285019081526000878152600390935294909120925183549451909116600160a01b026001600160e01b03199094169116179190911790555b83856001600160a01b0316876001600160a01b03167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef60405160405180910390a45b505050505050565b60006118017f56fc50411139d37d603be8c646a514a74d727c7be5c2dc1f9c0606059fa1c7c9336117a56040880160208901612a51565b6117b56060890160408a01612a51565b6040805160208101959095526001600160a01b039093169284019290925260ff908116606084015216608082015260a00160405160208183030381529060405280519060200120611e05565b90506118438184848080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250611e5392505050565b6001600160a01b0316611854610ed8565b6001600160a01b0316146111ae5760405162461bcd60e51b81526020600482015260176024820152761a5b9d985b1a59081bdc881d5b985d5d1a1bdc9a5e9959604a1b6044820152606401610696565b610cba828260405180602001604052806000815250611e77565b8047101561190e5760405162461bcd60e51b815260206004820152601d60248201527f416464726573733a20696e73756666696369656e742062616c616e63650000006044820152606401610696565b6000826001600160a01b03168260405160006040518083038185875af1925050503d806000811461195b576040519150601f19603f3d011682016040523d82523d6000602084013e611960565b606091505b50509050806107ca5760405162461bcd60e51b815260206004820152603a60248201527f416464726573733a20756e61626c6520746f2073656e642076616c75652c20726044820152791958da5c1a595b9d081b585e481a185d99481c995d995c9d195960321b6064820152608401610696565b60408051808201909152600080825260208201526119f3826000541190565b611a525760405162461bcd60e51b815260206004820152602a60248201527f455243373231413a206f776e657220717565727920666f72206e6f6e657869736044820152693a32b73a103a37b5b2b760b11b6064820152608401610696565b60007f00000000000000000000000000000000000000000000000000000000000000008310611ab357611aa57f000000000000000000000000000000000000000000000000000000000000000084612cef565b611ab0906001612c6c565b90505b825b818110611b1c576000818152600360209081526040918290208251808401909352546001600160a01b038116808452600160a01b9091046001600160401b03169183019190915215611b0957949350505050565b5080611b1481612d55565b915050611ab5565b5060405162461bcd60e51b815260206004820152602f60248201527f455243373231413a20756e61626c6520746f2064657465726d696e652074686560448201526e1037bbb732b91037b3103a37b5b2b760891b6064820152608401610696565b600880546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b60006001600160a01b0384163b15611cd157604051630a85bd0160e11b81526001600160a01b0385169063150b7a0290611c13903390899088908890600401612ac6565b602060405180830381600087803b158015611c2d57600080fd5b505af1925050508015611c5d575060408051601f3d908101601f19168201909252611c5a918101906128ad565b60015b611cb7573d808015611c8b576040519150601f19603f3d011682016040523d82523d6000602084013e611c90565b606091505b508051611caf5760405162461bcd60e51b815260040161069690612bf7565b805181602001fd5b6001600160e01b031916630a85bd0160e11b149050611cd5565b5060015b949350505050565b6060600a80546105a890612d6c565b606081611d105750506040805180820190915260018152600360fc1b602082015290565b8160005b8115611d3a5780611d2481612da7565b9150611d339050600a83612c84565b9150611d14565b6000816001600160401b03811115611d6257634e487b7160e01b600052604160045260246000fd5b6040519080825280601f01601f191660200182016040528015611d8c576020820181803683370190505b5090505b8415611cd557611da1600183612cef565b9150611dae600a86612dc2565b611db9906030612c6c565b60f81b818381518110611ddc57634e487b7160e01b600052603260045260246000fd5b60200101906001600160f81b031916908160001a905350611dfe600a86612c84565b9450611d90565b6000610593611e12612151565b8360405161190160f01b6020820152602281018390526042810182905260009060620160405160208183030381529060405280519060200120905092915050565b6000806000611e628585612278565b91509150611e6f816122e8565b509392505050565b6000546001600160a01b038416611eda5760405162461bcd60e51b815260206004820152602160248201527f455243373231413a206d696e7420746f20746865207a65726f206164647265736044820152607360f81b6064820152608401610696565b611ee5816000541190565b15611f325760405162461bcd60e51b815260206004820152601d60248201527f455243373231413a20746f6b656e20616c7265616479206d696e7465640000006044820152606401610696565b7f0000000000000000000000000000000000000000000000000000000000000000831115611fad5760405162461bcd60e51b815260206004820152602260248201527f455243373231413a207175616e7469747920746f206d696e7420746f6f2068696044820152610ced60f31b6064820152608401610696565b6001600160a01b0384166000908152600460209081526040918290208251808401845290546001600160801b038082168352600160801b9091041691810191909152815180830190925280519091908190612009908790612c4a565b6001600160801b031681526020018583602001516120279190612c4a565b6001600160801b039081169091526001600160a01b0380881660008181526004602090815260408083208751978301518716600160801b029790961696909617909455845180860186529182526001600160401b034281168386019081528883526003909552948120915182549451909516600160a01b026001600160e01b031990941694909216939093179190911790915582905b858110156121465760405182906001600160a01b038916906000907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef908290a461210a6000888488611bcf565b6121265760405162461bcd60e51b815260040161069690612bf7565b8161213081612da7565b925050808061213e90612da7565b9150506120bd565b506000819055611766565b6000306001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000161480156121aa57507f000000000000000000000000000000000000000000000000000000000000000046145b156121d457507f000000000000000000000000000000000000000000000000000000000000000090565b50604080517f00000000000000000000000000000000000000000000000000000000000000006020808301919091527f0000000000000000000000000000000000000000000000000000000000000000828401527f000000000000000000000000000000000000000000000000000000000000000060608301524660808301523060a0808401919091528351808403909101815260c0909201909252805191012090565b6000808251604114156122af5760208301516040840151606085015160001a6122a3878285856124e4565b945094505050506122e1565b8251604014156122d957602083015160408401516122ce8683836125c7565b9350935050506122e1565b506000905060025b9250929050565b600081600481111561230a57634e487b7160e01b600052602160045260246000fd5b14156123135750565b600181600481111561233557634e487b7160e01b600052602160045260246000fd5b141561237e5760405162461bcd60e51b815260206004820152601860248201527745434453413a20696e76616c6964207369676e617475726560401b6044820152606401610696565b60028160048111156123a057634e487b7160e01b600052602160045260246000fd5b14156123ee5760405162461bcd60e51b815260206004820152601f60248201527f45434453413a20696e76616c6964207369676e6174757265206c656e677468006044820152606401610696565b600381600481111561241057634e487b7160e01b600052602160045260246000fd5b14156124695760405162461bcd60e51b815260206004820152602260248201527f45434453413a20696e76616c6964207369676e6174757265202773272076616c604482015261756560f01b6064820152608401610696565b600481600481111561248b57634e487b7160e01b600052602160045260246000fd5b1415610ed55760405162461bcd60e51b815260206004820152602260248201527f45434453413a20696e76616c6964207369676e6174757265202776272076616c604482015261756560f01b6064820152608401610696565b6000806fa2a8918ca85bafe22016d0b997e4df60600160ff1b0383111561251157506000905060036125be565b8460ff16601b1415801561252957508460ff16601c14155b1561253a57506000905060046125be565b6040805160008082526020820180845289905260ff881692820192909252606081018690526080810185905260019060a0016020604051602081039080840390855afa15801561258e573d6000803e3d6000fd5b5050604051601f1901519150506001600160a01b0381166125b7576000600192509250506125be565b9150600090505b94509492505050565b6000806001600160ff1b03831660ff84901c601b016125e8878288856124e4565b935093505050935093915050565b82805461260290612d6c565b90600052602060002090601f016020900481019282612624576000855561266a565b82601f1061263d57805160ff191683800117855561266a565b8280016001018555821561266a579182015b8281111561266a57825182559160200191906001019061264f565b50610c749291505b80821115610c745760008155600101612672565b60006001600160401b03808411156126a0576126a0612e02565b604051601f8501601f19908116603f011681019082821181831017156126c8576126c8612e02565b816040528093508581528686860111156126e157600080fd5b858560208301376000602087830101525050509392505050565b803563ffffffff8116811461270f57600080fd5b919050565b803560ff8116811461270f57600080fd5b600060208284031215612736578081fd5b813561127a81612e18565b60008060408385031215612753578081fd5b823561275e81612e18565b9150602083013561276e81612e18565b809150509250929050565b60008060006060848603121561278d578081fd5b833561279881612e18565b925060208401356127a881612e18565b929592945050506040919091013590565b600080600080608085870312156127ce578081fd5b84356127d981612e18565b935060208501356127e981612e18565b92506040850135915060608501356001600160401b0381111561280a578182fd5b8501601f8101871361281a578182fd5b61282987823560208401612686565b91505092959194509250565b60008060408385031215612847578182fd5b823561285281612e18565b91506020830135801515811461276e578182fd5b60008060408385031215612878578182fd5b823561288381612e18565b946020939093013593505050565b6000602082840312156128a2578081fd5b813561127a81612e2d565b6000602082840312156128be578081fd5b815161127a81612e2d565b6000602082840312156128da578081fd5b81356001600160401b038111156128ef578182fd5b8201601f810184136128ff578182fd5b611cd584823560208401612686565b60008060008084860360a0811215612924578283fd5b6060811215612931578283fd5b5084935060608501356001600160401b038082111561294e578384fd5b818701915087601f830112612961578384fd5b81358181111561296f578485fd5b886020828501011115612980578485fd5b60208301955080945050505061299860808601612714565b905092959194509250565b600060a082840312156129b4578081fd5b60405160a081018181106001600160401b03821117156129d6576129d6612e02565b6040526129e283612714565b8152602083013561ffff811681146129f8578283fd5b6020820152612a09604084016126fb565b6040820152612a1a606084016126fb565b60608201526080830135612a2d81612e18565b60808201529392505050565b600060208284031215612a4a578081fd5b5035919050565b600060208284031215612a62578081fd5b61127a82612714565b60008151808452612a83816020860160208601612d29565b601f01601f19169290920160200192915050565b60008351612aa9818460208801612d29565b835190830190612abd818360208801612d29565b01949350505050565b6001600160a01b0385811682528416602082015260408101839052608060608201819052600090612af990830184612a6b565b9695505050505050565b60208152600061127a6020830184612a6b565b6020808252600f908201526e139bdd08195b9bdd59da08199d5b99608a1b604082015260600190565b60208082526012908201527114d85b1948185b1c9958591e48195b99195960721b604082015260600190565b60208082526010908201526f14d85b19481b9bdd081cdd185c9d195960821b604082015260600190565b6020808252818101527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604082015260600190565b60208082526013908201527245786365656420746f74616c20737570706c7960681b604082015260600190565b60208082526033908201527f455243373231413a207472616e7366657220746f206e6f6e204552433732315260408201527232b1b2b4bb32b91034b6b83632b6b2b73a32b960691b606082015260800190565b60006001600160801b03828116848216808303821115612abd57612abd612dd6565b60008219821115612c7f57612c7f612dd6565b500190565b600082612c9357612c93612dec565b500490565b60006001600160a01b0382811684821681151582840482111615612cbe57612cbe612dd6565b02949350505050565b60006001600160801b0383811690831681811015612ce757612ce7612dd6565b039392505050565b600082821015612d0157612d01612dd6565b500390565b600060ff821660ff841680821015612d2057612d20612dd6565b90039392505050565b60005b83811015612d44578181015183820152602001612d2c565b838111156111ae5750506000910152565b600081612d6457612d64612dd6565b506000190190565b600181811c90821680612d8057607f821691505b60208210811415612da157634e487b7160e01b600052602260045260246000fd5b50919050565b6000600019821415612dbb57612dbb612dd6565b5060010190565b600082612dd157612dd1612dec565b500690565b634e487b7160e01b600052601160045260246000fd5b634e487b7160e01b600052601260045260246000fd5b634e487b7160e01b600052604160045260246000fd5b6001600160a01b0381168114610ed557600080fd5b6001600160e01b031981168114610ed557600080fdfea2646970667358221220ffd0d9eff6aeb5dc587e1991984bc793f20a2af1b6d5b9693c5b338afaaa2ea464736f6c63430008040033";

export class SharkDooDoo__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _initStageInfo: {
      stageId: BigNumberish;
      maxSupply: BigNumberish;
      startTime: BigNumberish;
      endTime: BigNumberish;
      mintPrice: BigNumberish;
    },
    _initBaseURI: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SharkDooDoo> {
    return super.deploy(
      _initStageInfo,
      _initBaseURI,
      overrides || {}
    ) as Promise<SharkDooDoo>;
  }
  getDeployTransaction(
    _initStageInfo: {
      stageId: BigNumberish;
      maxSupply: BigNumberish;
      startTime: BigNumberish;
      endTime: BigNumberish;
      mintPrice: BigNumberish;
    },
    _initBaseURI: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _initStageInfo,
      _initBaseURI,
      overrides || {}
    );
  }
  attach(address: string): SharkDooDoo {
    return super.attach(address) as SharkDooDoo;
  }
  connect(signer: Signer): SharkDooDoo__factory {
    return super.connect(signer) as SharkDooDoo__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SharkDooDooInterface {
    return new utils.Interface(_abi) as SharkDooDooInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SharkDooDoo {
    return new Contract(address, _abi, signerOrProvider) as SharkDooDoo;
  }
}
